// File: /src/utils/countryTranslations.js

export const countryTranslations = {
	af: { display: 'Afeganistão', sort: 'afeganistao' },
	za: { display: 'África do Sul', sort: 'africa do sul' },
	al: { display: 'Albânia', sort: 'albania' },
	de: { display: 'Alemanha', sort: 'alemanha' },
	ad: { display: 'Andorra', sort: 'andorra' },
	ao: { display: 'Angola', sort: 'angola' },
	ai: { display: 'Anguilla', sort: 'anguilla' },
	aq: { display: 'Antártida', sort: 'antartida' },
	ag: { display: 'Antígua e Barbuda', sort: 'antigua e barbuda' },
	sa: { display: 'Arábia Saudita', sort: 'arabia saudita' },
	dz: { display: 'Argélia', sort: 'argelia' },
	ar: { display: 'Argentina', sort: 'argentina' },
	am: { display: 'Armênia', sort: 'armenia' },
	aw: { display: 'Aruba', sort: 'aruba' },
	au: { display: 'Austrália', sort: 'australia' },
	at: { display: 'Áustria', sort: 'austria' },
	az: { display: 'Azerbaijão', sort: 'azerbaijao' },
	bs: { display: 'Bahamas', sort: 'bahamas' },
	bh: { display: 'Bahrein', sort: 'bahrein' },
	bd: { display: 'Bangladesh', sort: 'bangladesh' },
	bb: { display: 'Barbados', sort: 'barbados' },
	by: { display: 'Bielorrússia', sort: 'bielorrussia' },
	be: { display: 'Bélgica', sort: 'belgica' },
	bz: { display: 'Belize', sort: 'belize' },
	bj: { display: 'Benin', sort: 'benin' },
	bm: { display: 'Bermudas', sort: 'bermudas' },
	bo: { display: 'Bolívia', sort: 'bolivia' },
	ba: { display: 'Bósnia e Herzegovina', sort: 'bosnia e herzegovina' },
	bw: { display: 'Botsuana', sort: 'botsuana' },
	br: { display: 'Brasil', sort: 'brasil' },
	bn: { display: 'Brunei', sort: 'brunei' },
	bg: { display: 'Bulgária', sort: 'bulgaria' },
	bf: { display: 'Burkina Faso', sort: 'burkina faso' },
	bi: { display: 'Burundi', sort: 'burundi' },
	bt: { display: 'Butão', sort: 'butao' },
	cv: { display: 'Cabo Verde', sort: 'cabo verde' },
	kh: { display: 'Camboja', sort: 'camboja' },
	cm: { display: 'Camarões', sort: 'camaroes' },
	ca: { display: 'Canadá', sort: 'canada' },
	qa: { display: 'Catar', sort: 'catar' },
	kz: { display: 'Cazaquistão', sort: 'cazaquistao' },
	td: { display: 'Chade', sort: 'chade' },
	cl: { display: 'Chile', sort: 'chile' },
	cn: { display: 'China', sort: 'china' },
	cy: { display: 'Chipre', sort: 'chipre' },
	co: { display: 'Colômbia', sort: 'colombia' },
	km: { display: 'Comores', sort: 'comores' },
	cg: { display: 'Congo', sort: 'congo' },
	kp: { display: 'Coreia do Norte', sort: 'coreia do norte' },
	kr: { display: 'Coreia do Sul', sort: 'coreia do sul' },
	ci: { display: 'Costa do Marfim', sort: 'costa do marfim' },
	cr: { display: 'Costa Rica', sort: 'costa rica' },
	hr: { display: 'Croácia', sort: 'croacia' },
	cu: { display: 'Cuba', sort: 'cuba' },
	dk: { display: 'Dinamarca', sort: 'dinamarca' },
	dj: { display: 'Djibuti', sort: 'djibuti' },
	dm: { display: 'Dominica', sort: 'dominica' },
	eg: { display: 'Egito', sort: 'egito' },
	sv: { display: 'El Salvador', sort: 'el salvador' },
	ae: { display: 'Emirados Árabes Unidos', sort: 'emirados arabes unidos' },
	ec: { display: 'Equador', sort: 'equador' },
	er: { display: 'Eritreia', sort: 'eritreia' },
	sk: { display: 'Eslováquia', sort: 'eslovakia' },
	si: { display: 'Eslovênia', sort: 'eslovenia' },
	es: { display: 'Espanha', sort: 'espanha' },
	us: { display: 'Estados Unidos', sort: 'estados unidos' },
	ee: { display: 'Estônia', sort: 'estonia' },
	et: { display: 'Etiópia', sort: 'etiopia' },
	fj: { display: 'Fiji', sort: 'fiji' },
	ph: { display: 'Filipinas', sort: 'filipinas' },
	fi: { display: 'Finlândia', sort: 'finlandia' },
	fr: { display: 'França', sort: 'franca' },
	ga: { display: 'Gabão', sort: 'gabao' },
	gm: { display: 'Gâmbia', sort: 'gambia' },
	gh: { display: 'Gana', sort: 'gana' },
	ge: { display: 'Geórgia', sort: 'georgia' },
	gi: { display: 'Gibraltar', sort: 'gibraltar' },
	gr: { display: 'Grécia', sort: 'grecia' },
	gd: { display: 'Grenada', sort: 'grenada' },
	gl: { display: 'Groenlândia', sort: 'groenlandia' },
	gp: { display: 'Guadalupe', sort: 'guadalupe' },
	gu: { display: 'Guam', sort: 'guam' },
	gt: { display: 'Guatemala', sort: 'guatemala' },
	gy: { display: 'Guiana', sort: 'guiana' },
	gf: { display: 'Guiana Francesa', sort: 'guiana francesa' },
	gn: { display: 'Guiné', sort: 'guine' },
	gq: { display: 'Guiné Equatorial', sort: 'guine equatorial' },
	gw: { display: 'Guiné-Bissau', sort: 'guine-bissau' },
	ht: { display: 'Haiti', sort: 'haiti' },
	nl: { display: 'Holanda', sort: 'holanda' },
	hn: { display: 'Honduras', sort: 'honduras' },
	hk: { display: 'Hong Kong', sort: 'hong kong' },
	hu: { display: 'Hungria', sort: 'hungria' },
	ye: { display: 'Iêmen', sort: 'iemen' },
	in: { display: 'Índia', sort: 'india' },
	id: { display: 'Indonésia', sort: 'indonesia' },
	iq: { display: 'Iraque', sort: 'iraque' },
	ir: { display: 'Irã', sort: 'ira' },
	ie: { display: 'Irlanda', sort: 'irlanda' },
	is: { display: 'Islândia', sort: 'islandia' },
	il: { display: 'Israel', sort: 'israel' },
	it: { display: 'Itália', sort: 'italia' },
	jm: { display: 'Jamaica', sort: 'jamaica' },
	jp: { display: 'Japão', sort: 'japao' },
	jo: { display: 'Jordânia', sort: 'jordania' },
	kw: { display: 'Kuwait', sort: 'kuwait' },
	la: { display: 'Laos', sort: 'laos' },
	ls: { display: 'Lesoto', sort: 'lesoto' },
	lv: { display: 'Letônia', sort: 'letonia' },
	lb: { display: 'Líbano', sort: 'libano' },
	lr: { display: 'Libéria', sort: 'liberia' },
	ly: { display: 'Líbia', sort: 'libia' },
	li: { display: 'Liechtenstein', sort: 'liechtenstein' },
	lt: { display: 'Lituânia', sort: 'lituania' },
	lu: { display: 'Luxemburgo', sort: 'luxemburgo' },
	mo: { display: 'Macau', sort: 'macau' },
	mk: { display: 'Macedônia do Norte', sort: 'macedonia do norte' },
	mg: { display: 'Madagascar', sort: 'madagascar' },
	my: { display: 'Malásia', sort: 'malasia' },
	mw: { display: 'Malawi', sort: 'malawi' },
	mv: { display: 'Maldivas', sort: 'maldivas' },
	ml: { display: 'Mali', sort: 'mali' },
	mt: { display: 'Malta', sort: 'malta' },
	ma: { display: 'Marrocos', sort: 'marrocos' },
	mq: { display: 'Martinica', sort: 'martinica' },
	mu: { display: 'Maurício', sort: 'mauricio' },
	mr: { display: 'Mauritânia', sort: 'mauritania' },
	mx: { display: 'México', sort: 'mexico' },
	mm: { display: 'Mianmar', sort: 'mianmar' },
	fm: { display: 'Micronésia', sort: 'micronesia' },
	mz: { display: 'Moçambique', sort: 'mocambique' },
	md: { display: 'Moldávia', sort: 'moldavia' },
	mc: { display: 'Mônaco', sort: 'monaco' },
	mn: { display: 'Mongólia', sort: 'mongolia' },
	me: { display: 'Montenegro', sort: 'montenegro' },
	ms: { display: 'Montserrat', sort: 'montserrat' },
	na: { display: 'Namíbia', sort: 'namibia' },
	nr: { display: 'Nauru', sort: 'nauru' },
	np: { display: 'Nepal', sort: 'nepal' },
	ni: { display: 'Nicarágua', sort: 'nicaragua' },
	ne: { display: 'Níger', sort: 'niger' },
	ng: { display: 'Nigéria', sort: 'nigeria' },
	no: { display: 'Noruega', sort: 'noruega' },
	nc: { display: 'Nova Caledônia', sort: 'nova caledonia' },
	nz: { display: 'Nova Zelândia', sort: 'nova zelandia' },
	om: { display: 'Omã', sort: 'oma' },
	pw: { display: 'Palau', sort: 'palau' },
	pa: { display: 'Panamá', sort: 'panama' },
	pg: { display: 'Papua Nova Guiné', sort: 'papua nova guine' },
	pk: { display: 'Paquistão', sort: 'paquistao' },
	py: { display: 'Paraguai', sort: 'paraguai' },
	pe: { display: 'Peru', sort: 'peru' },
	pf: { display: 'Polinésia Francesa', sort: 'polinesia francesa' },
	pl: { display: 'Polônia', sort: 'polonia' },
	pr: { display: 'Porto Rico', sort: 'porto rico' },
	pt: { display: 'Portugal', sort: 'portugal' },
	ke: { display: 'Quênia', sort: 'kenia' },
	kg: { display: 'Quirguistão', sort: 'quirguistao' },
	gb: { display: 'Reino Unido', sort: 'reino unido' },
	cf: {
		display: 'República Centro-Africana',
		sort: 'republica centro-africana',
	},
	cz: { display: 'República Tcheca', sort: 'republica tcheca' },
	do: { display: 'República Dominicana', sort: 'republica dominicana' },
	re: { display: 'Reunião', sort: 'reuniao' },
	ro: { display: 'Romênia', sort: 'romenia' },
	rw: { display: 'Ruanda', sort: 'ruanda' },
	ru: { display: 'Rússia', sort: 'russia' },
	eh: { display: 'Saara Ocidental', sort: 'saara ocidental' },
	pm: { display: 'Saint Pierre e Miquelon', sort: 'saint pierre e miquelon' },
	ws: { display: 'Samoa', sort: 'samoa' },
	as: { display: 'Samoa Americana', sort: 'samoa americana' },
	sm: { display: 'San Marino', sort: 'san marino' },
	sh: { display: 'Santa Helena', sort: 'santa helena' },
	lc: { display: 'Santa Lúcia', sort: 'santa lucia' },
	kn: { display: 'São Cristóvão e Nevis', sort: 'sao cristovao e nevis' },
	st: { display: 'São Tomé e Príncipe', sort: 'sao tome e principe' },
	vc: {
		display: 'São Vicente e Granadinas',
		sort: 'sao vicente e granadinas',
	},
	sc: { display: 'Seicheles', sort: 'seicheles' },
	sn: { display: 'Senegal', sort: 'senegal' },
	sl: { display: 'Serra Leoa', sort: 'serra leoa' },
	rs: { display: 'Sérvia', sort: 'servia' },
	sg: { display: 'Singapura', sort: 'singapura' },
	sy: { display: 'Síria', sort: 'siria' },
	so: { display: 'Somália', sort: 'somalia' },
	lk: { display: 'Sri Lanka', sort: 'sri lanka' },
	sz: { display: 'Suazilândia', sort: 'suazilandia' },
	sd: { display: 'Sudão', sort: 'sudao' },
	se: { display: 'Suécia', sort: 'suecia' },
	ch: { display: 'Suíça', sort: 'suica' },
	sr: { display: 'Suriname', sort: 'suriname' },
	tj: { display: 'Tajiquistão', sort: 'tajiquistao' },
	th: { display: 'Tailândia', sort: 'tailandia' },
	tw: { display: 'Taiwan', sort: 'taiwan' },
	tz: { display: 'Tanzânia', sort: 'tanzania' },
	io: {
		display: 'Território Britânico do Oceano Índico',
		sort: 'territorio britanico do oceano indico',
	},
	tf: {
		display: 'Territórios Franceses do Sul',
		sort: 'territorios franceses do sul',
	},
	ps: { display: 'Territórios Palestinos', sort: 'territorios palestinos' },
	tl: { display: 'Timor-Leste', sort: 'timor-leste' },
	tg: { display: 'Togo', sort: 'togo' },
	to: { display: 'Tonga', sort: 'tonga' },
	tt: { display: 'Trinidad e Tobago', sort: 'trinidad e tobago' },
	tn: { display: 'Tunísia', sort: 'tunisia' },
	tm: { display: 'Turcomenistão', sort: 'turcomenistao' },
	tr: { display: 'Turquia', sort: 'turquia' },
	tv: { display: 'Tuvalu', sort: 'tuvalu' },
	ua: { display: 'Ucrânia', sort: 'ucrania' },
	ug: { display: 'Uganda', sort: 'uganda' },
	uy: { display: 'Uruguai', sort: 'uruguai' },
	uz: { display: 'Uzbequistão', sort: 'uzbequistao' },
	vu: { display: 'Vanuatu', sort: 'vanuatu' },
	va: { display: 'Vaticano', sort: 'vaticano' },
	ve: { display: 'Venezuela', sort: 'venezuela' },
	vn: { display: 'Vietnã', sort: 'vietna' },
	wf: { display: 'Wallis e Futuna', sort: 'wallis e futuna' },
	zm: { display: 'Zâmbia', sort: 'zambia' },
	zw: { display: 'Zimbábue', sort: 'zimbabue' },
};

export default countryTranslations;
